// Событие лида для Meta Pixel. Сам пиксель инициализируется в шаблоне
// (partials/meta-pixel.blade.php, только рекламная посадочная), сюда вынесена отправка
// события: по успешной отправке формы «Submit request», как у Telegram-пикселя рядом.
export function trackMetaLead() {
  // fbq объявляется синхронно вместе с инициализацией и копит вызовы до загрузки
  // fbevents.js. Опциональный вызов — на страницах без пикселя (или при адблоке)
  // отправка формы не должна падать.
  window.fbq?.('track', 'Lead');
}
